import React from 'react';
import PageAuthorize from '../../../../security/PageAuthorize';
import Comparison from '../../../../prototypes/Comparison';
import ListContainer from '../../../../presentation/ListContainer';
import layout from './DipServicesAlerts.json';
import DipServiceDialog  from './DipServiceDialog.js';
import EtelAPI from '../../../../api/EtelAPI.js';
import Alerts from '../../../../prototypes/Alerts.js';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { clearUserProfile } from '../../../../redux/actions/user';
import { clearBugsnagUser } from '../../../../redux/actions/bugsnag';

class DipServicesAlertsList extends React.Component {
  constructor( props ) {
    super( props );
    this.state = { 
      row: props.row === undefined ? {} : props.row,
      parentrow: {},
      showDialog: false,
      dialogMode: 'EDIT'
    };

    this.onIconClicked = this.onIconClicked.bind( this );
    this.onClose = this.onClose.bind( this );
    this.onSave = this.onSave.bind( this );
  }

  static getDerivedStateFromProps( props, state ) {
    let newState = state;
    let stateChanged = false;

    if( props.row !== undefined ) {
      const compare = new Comparison( props.row, state.row );
      if( compare.isMatch(compare.MatchTypes.DataRow) === false ) {
        newState.row = props.row;
        stateChanged = true;
      }
    }

    if( stateChanged === true ) {
      return newState;
    }

    return null;
  }

  // Handles exceptions
  onHandleException( e ) {
    const title = 'Dip Services';
    const bugsnag = this.props.bugsnag;
    const { dispatch } = this.props;
    const alerts = new Alerts( bugsnag, dispatch );
    const status = e.status === undefined ? 0 : e.status;
    if( status === 410 ) {
      alerts.INFO( title, 'Your session has expired.' , 5000 );
      this.doLogOff();
    } else if( status === 500 ) {
      alerts.INFO( title, e.statusText , 5000 );
      this.doLogOff();
    // This only needs to warn the user
    } else if( status === 400 ) {
      alerts.WARNING( title, 'Request timed out.', 5000 );
    } else {
      alerts.CRITICAL( title, e );
    }
  }
  
  // Returns user back to the login page if creds fail
  doLogOff( ) {
    const { dispatch } = this.props;
    const auth = this.props.auth;
    const history = this.props.history;
    auth.logout();
    dispatch( clearBugsnagUser() );
    dispatch( clearUserProfile() );
    history.push( '/login' );
  }
  
  onIconClicked( args ) {
    let api = new EtelAPI('dipservices');
    let parameters = [
      {"ID": args.row.DIP_SERVICES_ID }
    ];
    api.get( parameters ).then( ( result ) => { 
      this.setState( { 
        row: args.row,
        parentrow: result[0],
        dialogMode: 'EDIT',
        showDialog: true
      } );
    } ).catch( ( exception ) => { 
      this.onHandleException( exception );
    } );
  }

  onClose( e ) {
    this.setState( { 
      showDialog: false
    } );
  }

  onSave( e ) {
    this.setState( { 
      showDialog: false
    } );
  }

  render(){
    return (
      <PageAuthorize groups={['Administrators','Operations']}>
        <ListContainer
          id="DipServicesAlertsList"
          layout={layout}
          onIconClicked={this.onIconClicked}
          selectedtab={2}
        />
        <DipServiceDialog 
          mode={this.state.dialogMode}
          show={this.state.showDialog} 
          onClose={this.onClose}
          onSave={this.onSave}
          row={this.state.parentrow}
          childrow={this.state.row}
        />                
      </PageAuthorize>
    );
  }
}

// Exports
export default withRouter(
  connect (
    ( store ) => {
      return {
        auth: store.auth.auth,
        bugsnag: store.bugsnag.Bugsnag,
        user: store.user.user
      };
    }
  )( DipServicesAlertsList ) 
);


// WEBPACK FOOTER //
// ./src/content/technical/dipservices/components/DipServicesAlertsList.js